var map = {
	"./cavePhoto_largest.webp.jpg": 6174,
	"./home1.jpg": 1163,
	"./home2.jpg": 4878,
	"./home3.jpg": 6914,
	"./home4.jpg": 4598,
	"./home5.jpg": 3352,
	"./home6.jpg": 348,
	"./homePhoto.jpg": 4054,
	"./majorTom.jpg": 4737,
	"./waterPhoto.jpg": 2004
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4661;